import VueRouter from 'vue-router'
import Vue from 'vue'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import Dashboard from '../views/Dashboard.vue'
import DataBoard from '../views/DataBoard.vue'
import RobotList from '../views/RobotList.vue'
import RobotDetail from '../views/RobotDetail.vue'
import WorkLogList from '../views/WorkLogList.vue'
import WorkLogDetail from '../views/WorkLogDetail.vue'
import WorkLogStream from '../views/WorkLogStream.vue'
import ProjectList from '../views/ProjectList.vue'
import ProjectDetail from '../views/ProjectDetail.vue'
import StepTemplate from '../views/StepTemplate.vue'
import TemplateDetail from '../views/TemplateDetail.vue'
import ApiKeyManager from '../views/ApiKeyManager.vue'
import ApiKeyLog from '../views/ApiKeyLog.vue'
import Profile from '../views/Profile.vue'
import TaskManager from '../views/TaskManager.vue'
import TaskCreate from '../views/TaskCreate.vue'
import TaskDetail from '../views/TaskDetail.vue'
import SessionManager from '../views/SessionManager.vue'
import SessionDetail from '../views/SessionDetail.vue'
import SummaryList from '../views/SummaryList.vue'
import SummaryDetail from '../views/SummaryDetail.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: '涟漪',
      requiresAuth: false
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      title: '登录',
      requiresAuth: false
    }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      title: '概览',
      requiresAuth: true
    }
  },
  {
    path: '/stats',
    name: 'DataBoard',
    component: DataBoard,
    meta: {
      title: '数据看板',
      requiresAuth: true
    }
  },
  {
    path: '/robots',
    name: 'RobotList',
    component: RobotList,
    meta: {
      title: '机器人列表',
      requiresAuth: true
    }
  },
  {
    path: '/robot/:id',
    name: 'RobotDetail',
    component: RobotDetail,
    meta: {
      title: '机器人详情',
      requiresAuth: true
    },
    props: true
  },
  {
    path: '/work-logs',
    name: 'WorkLogList',
    component: WorkLogList,
    meta: {
      title: '工作日志列表',
      requiresAuth: true
    }
  },
  {
    path: '/work-log/:id',
    name: 'WorkLogDetail',
    component: WorkLogDetail,
    meta: {
      title: '工作日志详情',
      requiresAuth: true
    },
    props: true
  },
  {
    path: '/work-log-stream',
    name: 'WorkLogStream',
    component: WorkLogStream,
    meta: {
      title: '工作日志实时动态',
      requiresAuth: true
    }
  },
  {
    path: '/projects',
    name: 'ProjectList',
    component: ProjectList,
    meta: {
      title: '项目列表',
      requiresAuth: true
    }
  },
  {
    path: '/project/:id',
    name: 'ProjectDetail',
    component: ProjectDetail,
    meta: {
      title: '项目详情',
      requiresAuth: true
    },
    props: true
  },
  {
    path: '/templates',
    name: 'StepTemplate',
    component: StepTemplate,
    meta: {
      title: '步骤模板管理',
      requiresAuth: true
    }
  },
  {
    path: '/template/:id',
    name: 'TemplateDetail',
    component: TemplateDetail,
    meta: {
      title: '模板详情',
      requiresAuth: true
    },
    props: true
  },
  {
    path: '/apikeys',
    name: 'ApiKeyManager',
    component: ApiKeyManager,
    meta: {
      title: 'API Key管理',
      requiresAuth: true
    }
  },
  {
    path: '/apikeys/log',
    name: 'ApiKeyLog',
    component: ApiKeyLog,
    meta: {
      title: 'API调用日志',
      requiresAuth: true
    }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    meta: {
      title: '个人中心',
      requiresAuth: true
    }
  },
  {
    path: '/tasks',
    name: 'TaskManager',
    component: TaskManager,
    meta: {
      title: '任务管理',
      requiresAuth: true
    }
  },
  {
    path: '/tasks/create',
    name: 'TaskCreate',
    component: TaskCreate,
    meta: {
      title: '创建任务',
      requiresAuth: true
    }
  },
  {
    path: '/task/:id',
    name: 'TaskDetail',
    component: TaskDetail,
    meta: {
      title: '任务详情',
      requiresAuth: true
    },
    props: true
  },
  {
    path: '/sessions',
    name: 'SessionManager',
    component: SessionManager,
    meta: {
      title: '会话管理',
      requiresAuth: true
    }
  },
  {
    path: '/session/:id',
    name: 'SessionDetail',
    component: SessionDetail,
    meta: {
      title: '会话详情',
      requiresAuth: true
    },
    props: true
  },
  {
    path: '/summary-list',
    name: 'SummaryList',
    component: SummaryList,
    meta: {
      title: '工作总结列表',
      requiresAuth: true
    }
  },
  {
    path: '/summary/:id',
    name: 'SummaryDetail',
    component: SummaryDetail,
    meta: {
      title: '工作总结详情',
      requiresAuth: true
    },
    props: true
  }
]

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes
})

// 全局路由守卫
router.beforeEach((to, from, next) => {
  // 设置页面标题
  document.title = `${to.meta.title} - RippleX`
  
  // 检查是否需要登录认证
  if (to.meta.requiresAuth) {
    // 检查用户登录状态
    const isLoggedIn = localStorage.getItem('token')
    if (!isLoggedIn) {
      // 如果已经在登录页面，不做任何操作
      if (from.path === '/login') {
        next(false)
      } else {
        // 重定向到登录页面
        next('/login')
      }
      return
    }
  }
  
  next()
})

export default router
